import { render } from "./DropdownCurrencyLanguage.vue?vue&type=template&id=151a4694"
import script from "./DropdownCurrencyLanguage.vue?vue&type=script&lang=js"
export * from "./DropdownCurrencyLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/common/header/parts/DropdownCurrencyLanguage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "151a4694"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('151a4694', __exports__)) {
    api.reload('151a4694', __exports__)
  }
  
  module.hot.accept("./DropdownCurrencyLanguage.vue?vue&type=template&id=151a4694", () => {
    api.rerender('151a4694', render)
  })

}


export default __exports__